import {
  AUTH_HIDE_VERIFICATION_MODAL,
  AUTH_SHOW_VERIFICATION_MODAL,
  CLEAR_VERIFICATION_QUEUE,
  PUSH_POST_VERIFICATION_QUEUE_ITEM,
} from '../actionTypes'

export const defaultState = {
  modalOpen: false,
  postVerificationQueue: [],
}

/*
The queue is used for async jobs that need to be executed when something
else happens in the application. For example, the verificationQueue should hold
all functions that need to be executed once a user is verified with the app
following a short_term expiration.
Because they hold function references, nothing should ever be added to a queue
from the server process -- these are strictly client side operations.
All queue entries should be of the form *Tuple<Function fn, Object args>*.
 */
const verificationModalReducer = (state = defaultState, action) => {
  switch (action.type) {
    case AUTH_SHOW_VERIFICATION_MODAL:
      return {
        ...state,
        modalOpen: true,
      }
    case AUTH_HIDE_VERIFICATION_MODAL:
      return {
        ...state,
        modalOpen: false,
      }
    case PUSH_POST_VERIFICATION_QUEUE_ITEM:
      return {
        ...state,
        postVerificationQueue: [...state.postVerificationQueue, action.item],
      }
    case CLEAR_VERIFICATION_QUEUE:
      return {
        ...state,
        postVerificationQueue: [],
      }
    default:
      return state
  }
}

export default verificationModalReducer
